export default "__VITE_ASSET__DV1RVsId__"